import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getGlobalLeaderboard } from '../firebase';
import { getCurrentLevel } from '../utils/achievements';
import './Leaderboard.css';
import LeaderboardTable from './LeaderboardTable';

function Leaderboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadGlobalLeaderboard();
  }, []);

  const loadGlobalLeaderboard = async () => {
    try {
      const leaderboardData = await getGlobalLeaderboard(100);
      setLeaderboard(leaderboardData);
    } catch (error) {
      console.error('Error loading global leaderboard:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleStartWorkout = () => {
    navigate('/workouts/players');
  };

  const handleStartSkill = () => {
    navigate('/skills/players');
  };

  if (loading) {
    return (
      <div className='leaderboard-page'>
        <div className='loading'>Loading leaderboard...</div>
      </div>
    );
  }

  return (
    <div className='leaderboard-page'>
      <div className='leaderboard-header'>
        <h1>Global Leaderboard</h1>
        <p className='subtitle'>
          See who's leading the fitness challenge worldwide!
        </p>
      </div>

      {/* Leaderboard Stats */}
      <div className='leaderboard-stats'>
        <div className='stat-item'>
          <div className='stat-number'>{leaderboard.length}</div>
          <div className='stat-label'>Players</div>
        </div>
        <div className='stat-item'>
          <div className='stat-number'>
            {leaderboard.reduce((sum, player) => sum + player.totalPoints, 0)}
          </div>
          <div className='stat-label'>Total Points</div>
        </div>
        <div className='stat-item'>
          <div className='stat-number'>
            {
              leaderboard.filter(
                (player) =>
                  player.lastActive &&
                  Date.now() - player.lastActive.toDate() < 24 * 60 * 60 * 1000
              ).length
            }
          </div>
          <div className='stat-label'>Recently Active Players</div>
        </div>
      </div>

      {/* Main Leaderboard */}
      <LeaderboardTable
        rows={leaderboard.map((p) => {
          const levelInfo = getCurrentLevel(p.totalPoints || 0);
          return {
            id: p.playerId,
            rank: p.rank,
            avatar: p.avatar,
            name: p.playerId,
            points: p.totalPoints || 0,
            levelNumber: levelInfo.level,
            levelEmoji: levelInfo.emoji,
          };
        })}
        onNameClick={(row) => navigate(`/profile/${row.id}`)}
      />

      {/* Call to Action */}
      <div className='leaderboard-cta'>
        <h3>Ready to climb the ranks?</h3>
        <p>Start a workout to earn points and move up the leaderboard!</p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <button className='cta-button' onClick={handleStartWorkout}>
            Strength Workout
          </button>
          <button className='cta-button' onClick={handleStartSkill}>
            Skill Session
          </button>
        </div>
      </div>
    </div>
  );
}

export default Leaderboard;
